import Bugsnag from 'bugsnag-js';
/*loads configuration options for dev,qa, prod, etc based on TROPIC_CONFIG environment variable, see webpack.config.js*/
import frontEndConfig from 'config';


Bugsnag.apiKey = frontEndConfig.bugsnag.apiKey;
Bugsnag.releaseStage = frontEndConfig.bugsnag.releaseStage;


export default Bugsnag;/*export a Bugsnag object with custom settings overwritten*/